import React, { Component } from "react";
import SidebarContainer from "./SidebarContainer";
import { Toolbar } from "primereact/toolbar";
import { withContext } from "../shared/withContext";
import { ContextIF } from "../../App";
import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import { withRouter } from "react-router";
interface Props {
    context: ContextIF;
    history: any;
}
interface State {}

class Layout extends Component<Props, State> {
    state = {};

    render() {
        return (
            <div>
                <div className="wrap">
                    <div className="main">
                        <Toolbar
                            className="app-header"
                            left={
                                <>
                                    <SidebarContainer />
                                    <span className="app-brand">
                                        Tischharfe stimmen
                                    </span>
                                </>
                            }
                            right={
                                <>
                                    {this.props.context.user ? (
                                        <Avatar
                                            icon="pi pi-user"
                                            shape="circle"
                                            onClick={() =>
                                                this.props.history.push(
                                                    "/account"
                                                )
                                            }
                                        />
                                    ) : (
                                        <Button
                                            label="Login"
                                            className="p-button-sm p-button-outlined"
                                            onClick={() =>
                                                this.props.history.push("/login")
                                            }
                                        />
                                    )}
                                </>
                            }
                        ></Toolbar>

                        <div id="wrapper" className="p-d-flex">
                            <div
                                id="content-wrapper"
                                className="p-d-flex p-flex-column w-100"
                            >
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(withContext(Layout));
